/* <tx-slider>: scroll-snap slider with page dots + optional autoplay (data-autoplay ms).
   Used by snippets/testimonials-experts.liquid and sections/formula-highlights.liquid.
   Markup: a .tx-slider__track and .tx-slider__dot buttons inside <tx-slider>. */
/* Dots for the experts slider/carousel; swiping and snapping are native CSS.
   A "page" is one track width, so 1 card per view (split) and 3 per view (carousel) both work. */
if (!customElements.get('tx-slider')) {
  customElements.define('tx-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tx-slider__track');
      this.dots = [...this.querySelectorAll('.tx-slider__dot')];
      if (!this.track || !this.dots.length) return;
      this.current = 0;
      this.pages = this.dots.length;
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
      this.track.addEventListener('scroll', () => {
        this.current = Math.round(this.track.scrollLeft / this.pageWidth());
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.current)));
      }, { passive: true });
      // Only as many dots as there are pages at the current width.
      this.resizer = new ResizeObserver(() => {
        this.pages = Math.max(1, Math.ceil((this.track.scrollWidth + this.gap()) / this.pageWidth() - 0.01));
        this.dots.forEach((dot, i) => (dot.hidden = i >= this.pages));
        this.dots[0].parentElement.hidden = this.pages < 2;
      });
      this.resizer.observe(this.track);

      // Auto-rotate (section "Auto-rotate" setting). Pauses while hovered/focused, stops after a
      // touch, and is skipped for reduced-motion users.
      const ms = Number(this.dataset.autoplay);
      if (ms > 0 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let paused = false;
        this.addEventListener('pointerenter', () => (paused = true));
        this.addEventListener('pointerleave', () => (paused = false));
        this.addEventListener('focusin', () => (paused = true));
        this.addEventListener('focusout', () => (paused = false));
        this.addEventListener('touchstart', () => clearInterval(this.timer), { passive: true });
        this.timer = setInterval(() => {
          if (!paused && !document.hidden) this.go((this.current + 1) % this.pages);
        }, ms);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.resizer) this.resizer.disconnect();
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap) || 0;
    }

    pageWidth() {
      return this.track.clientWidth + this.gap();
    }

    go(i) {
      this.track.scrollTo({ left: i * this.pageWidth() });
    }
  });
}
